/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Default_Background_Color_TransparentInputs */

const en_options_display_default_background_color_transparent = /** @type {(inputs: Options_Display_Default_Background_Color_TransparentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparent`)
};

const fr_options_display_default_background_color_transparent = /** @type {(inputs: Options_Display_Default_Background_Color_TransparentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparent`)
};

const de_options_display_default_background_color_transparent = /** @type {(inputs: Options_Display_Default_Background_Color_TransparentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparent`)
};

const it_options_display_default_background_color_transparent = /** @type {(inputs: Options_Display_Default_Background_Color_TransparentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasparente`)
};

const ru_options_display_default_background_color_transparent = /** @type {(inputs: Options_Display_Default_Background_Color_TransparentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прозрачный`)
};

const es_options_display_default_background_color_transparent = /** @type {(inputs: Options_Display_Default_Background_Color_TransparentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparente`)
};

const zh_cn2_options_display_default_background_color_transparent = /** @type {(inputs: Options_Display_Default_Background_Color_TransparentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`透明`)
};

const ja_options_display_default_background_color_transparent = /** @type {(inputs: Options_Display_Default_Background_Color_TransparentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`透明`)
};

const hi_options_display_default_background_color_transparent = /** @type {(inputs: Options_Display_Default_Background_Color_TransparentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पारदर्शी`)
};

const pt_pt2_options_display_default_background_color_transparent = /** @type {(inputs: Options_Display_Default_Background_Color_TransparentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparente`)
};

/**
* | output |
* | --- |
* | "Transparent" |
*
* @param {Options_Display_Default_Background_Color_TransparentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_default_background_color_transparent = /** @type {((inputs?: Options_Display_Default_Background_Color_TransparentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Default_Background_Color_TransparentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_default_background_color_transparent(inputs)
	if (locale === "de") return de_options_display_default_background_color_transparent(inputs)
	if (locale === "it") return it_options_display_default_background_color_transparent(inputs)
	if (locale === "ru") return ru_options_display_default_background_color_transparent(inputs)
	if (locale === "es") return es_options_display_default_background_color_transparent(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_default_background_color_transparent(inputs)
	if (locale === "ja") return ja_options_display_default_background_color_transparent(inputs)
	if (locale === "hi") return hi_options_display_default_background_color_transparent(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_default_background_color_transparent(inputs)
	return en_options_display_default_background_color_transparent(inputs)
});